module.exports = __webpack_public_path__ + "img/financial-welfare.2760a929.png";